import type { IconNode } from '../types';

/**
 * @name scan-box
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJ2NS41IiAvPgogIDxwYXRoIGQ9Ik0xNyAzaDJhMiAyIDAgMDEyIDJ2MiIgLz4KICA8cGF0aCBkPSJNMjEgMTd2MmEyIDIgMCAwMS0yIDJoLTIiIC8+CiAgPHBhdGggZD0iTTMgN1Y1YTIgMiAwIDAxMi0yaDIiIC8+CiAgPHBhdGggZD0iTTcgMjFINWEyIDIgMCAwMS0yLTJ2LTIiIC8+CiAgPHBhdGggZD0iTTcuMjY0IDkuMjUyIDEyIDEybDQuNzM3LTIuNzQ4IiAvPgogIDxwYXRoIGQ9Ik03Ljk5NSA4LjUxNEEyIDIgMCAwMDcgMTAuMjQ0djMuNTE2YTIgMiAwIDAwLjk5NiAxLjczbDMgMS43NGEyIDIgMCAwMDIuMDA4IDBsMy0xLjc0QTIgMiAwIDAwMTcgMTMuNzZ2LTMuNTE3YTIgMiAwIDAwLS45OTUtMS43M2wtMy0xLjc0MmEyIDIgMCAwMC0xLjg5Mi0uMDY0eiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/scan-box
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ScanBox: IconNode = [
  ['path', { d: 'M12 12v5.5' }],
  ['path', { d: 'M17 3h2a2 2 0 012 2v2' }],
  ['path', { d: 'M21 17v2a2 2 0 01-2 2h-2' }],
  ['path', { d: 'M3 7V5a2 2 0 012-2h2' }],
  ['path', { d: 'M7 21H5a2 2 0 01-2-2v-2' }],
  ['path', { d: 'M7.264 9.252 12 12l4.737-2.748' }],
  [
    'path',
    {
      d: 'M7.995 8.514A2 2 0 007 10.244v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0017 13.76v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z',
    },
  ],
];

export default ScanBox;
